<template>
    <el-tabs type="border-card" v-model="activeTab" @click.native="handleTabClick">
        <el-tab-pane label="Upload" name="import">
            <PDFImport />
        </el-tab-pane>
        <el-tab-pane label="Result" name="result">
            <PDFResult ref="pdfResult"/>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import PDFResult from './components/PDFResults';
import PDFImport from './components/PDFImport';

export default {
    components: { PDFResult, PDFImport },
    data: () => ({
        activeTab: 'import'
    }),
    methods: {
        handleTabClick(){
            if(this.activeTab === 'result'){
                this.$refs['pdfResult'].search = ''
            }
        }
    }
}
</script>

<style scoped>
.el-tabs {
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}
</style>